<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Movimentação Mínima
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirMovimentacao"
			hide-footer
		>
			<div slot="modal-title">
				Movimentações Mínimas -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<movimentacoes-form
				tipoOperacao="i"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterMovimentacoesAtualizadas="$emit('obterMovimentacoesAtualizadas')"
				:contrato="contrato"
				:unidadesDeMedida="unidadesDeMedida"
			></movimentacoes-form>
		</b-modal>
    </div>
</template>

<script>
import MovimentacoesForm from './MovimentacoesForm'

export default {
	components: {
		MovimentacoesForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		},

		unidadesDeMedida: {
			type: Array
		}
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},
}
</script>
